// Libraries
import React from 'react';

// Supermove
import {Icon} from '@supermove/components';
import {usePopover} from '@supermove/hooks';
import {colors} from '@supermove/styles';

// App
import IconButton from '@shared/design/components/IconButton';
import HelpCenterPopover from '@shared/modules/App/components/HelpCenterPopover';

const HelpCenterButton = ({
  referralUtmSource,
  showChatOption,
}: {
  referralUtmSource: string;
  showChatOption: boolean;
}) => {
  const helpCenterPopover = usePopover({name: 'Global Header Help Dropdown', enableTracking: true});

  return (
    <HelpCenterPopover
      helpCenterPopover={helpCenterPopover}
      referralUtmSource={referralUtmSource}
      showChatOption={showChatOption}
    >
      <IconButton
        source={Icon.CommentQuestion}
        onPress={helpCenterPopover.handleOpen}
        color={colors.white}
      />
    </HelpCenterPopover>
  );
};

export default HelpCenterButton;
